// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * [[DeviceEventAttributes]] describes a device event.
 */
export default interface DeviceEventAttributes {
  audioInputErrorMessage?: string;
  videoInputErrorMessage?: string;
  deviceLabelTriggerErrorMessage?: string;
}
